// ACHTUNG!!! SEO-kritische Komponente, Direkte Importe und Backendaufrufe sollten so gering wie nur möglich gehalten werden 


import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { InfoletterHeaderComponent } from "@app/components/infoletter-header/infoletter-header.component";
import { isNullish } from '@commonHelpers/math-utils';
import { AccountLanguage } from '@interfaces/HttpClient/AccountApiPublicModels';
import { SoftwareIntegrationCallbackService } from '@services/software-integration-callback.service';
import { SoftwarepartnerApiService } from '@services/softwarepartner-api.service';
import { HelpPublicComponent } from "../../../components/help-public/help-public.component";
import { LanguageComponent } from "../../../components/language/language.component";
import { UserMenuContextComponent } from "../../../components/user-menu/user-menu-context/user-menu-context.component";
import { WatchlistHeaderNavigationComponent } from "../../../components/watchlist-header-navigation/watchlist-header-navigation.component";
import { HeaderBurgerMenuComponent } from "../header-burger-menu/header-burger-menu.component";

@Component({
	selector: 'app-mobile-header',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './mobile-header.component.html',
	styleUrls: ['./mobile-header.component.scss'],
	imports: [NgClass, RouterModule, HeaderBurgerMenuComponent, HelpPublicComponent, UserMenuContextComponent, WatchlistHeaderNavigationComponent, LanguageComponent, InfoletterHeaderComponent]
})
export class MobileHeaderComponent implements OnInit {
	public catalogKey = input<string>();
	public theme = input<"ade" | "neutral">("neutral");
	public showLanguage = input<boolean>(false);
	public showWatchlist = input<boolean>(false);
	public showInfoletter = input<boolean>(false);
	public languageChange = output<AccountLanguage>();
	public signetClick = output();
	public hasWatchlist = false;

	constructor(private softwareIntegrationService: SoftwareIntegrationCallbackService, private softwarepartnerApiService: SoftwarepartnerApiService) {

	}
	ngOnInit(): void {
		this.hasWatchlist = this.showWatchlist && !this.softwareIntegrationService.hasSession() && !this.softwarepartnerApiService.hasSession();;

		if (!isNullish(document.getElementById('defaultPreloadContent'))) {
			requestAnimationFrame(() => {
				const preloads = document.querySelectorAll("[data-seo-preload]");
				preloads.forEach(preload => {
					preload?.remove();
				});
			}
			);
		}
	}



}
